import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  medicamentoInfoContainer: {
    height: "12vh",
    boxShadow: "0 0 0.5rem 0"
  },

  medicamentoInfoStyle: {
    paddingLeft: "0.8rem",
    width: '80vw',
    [theme.breakpoints.up('sm')]: {
      paddingLeft: '1.5rem'
    }
  },

  medicamentoCodigoStyle: {
    fontSize: '0.85rem',
    fontWeight: 700,
    [theme.breakpoints.up('sm')]: {
      fontSize: '1rem'
    }
  },

  medicamentoNomeStyle: {
    fontSize: '0.85rem',
    lineHeight: '1.1rem',
    overflow: 'hidden',
    [theme.breakpoints.up('sm')]: {
      fontSize: '1rem'
    }
  },

  quantidadeTotalCores: {
    color: theme.palette.grey[500],
    backgroundColor: theme.palette.grey[100],
  },

  quantidadeContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    width: '25vw',
    [theme.breakpoints.up('sm')]: {
      width: '15vw',
    }
  },

  quantidadeLabel: {
    padding: '0.3rem 0.1rem 0',
    textAlign: 'center',
    fontSize: '0.75rem',
    fontWeight: 700,
    [theme.breakpoints.up('sm')]: {
      fontSize: '0.65rem'
    }
  },

  quantidadeValor: {
    fontSize: '1.8rem',
    fontWeight: 700,
    marginTop: '-0.4rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '2.1rem',
    }
  },

  quantidadeRestanteCompleto: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.success.main,
  },

  quantidadeRestantePendente: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.info.main,
  },

  formPadding: {
    flexGrow: 1,
    padding: '0.5rem'
  },

  titleContainer: {
    alignItems: 'center'
  },

  titleStyle: {
    paddingLeft: '1rem',
    fontSize: '1rem',
    fontWeight: 500,
    [theme.breakpoints.up('sm')]: {
      fontSize: '1.3rem',
    }
  },

  breakLine: {
    height: '2px',
    marginBottom: '1vh',
    backgroundColor: theme.palette.divider,
  },

  innerFormContainerMedicamento: {
    gap: '2%',
    padding: '0 0.2rem',
    margin: '0.5rem 0',
    overflow: 'auto',
    overflowX: 'hidden',
    flexGrow: 1,
    height: 0,
    [theme.breakpoints.up('sm')]: {
      width: '100%',
      alignSelf: 'center'
    }
  },

  cardMedicamentoItem: {
    justifyContent: 'center',
  },

  buttonContainer: {
    gap: '5%',
    height: '4rem',
    [theme.breakpoints.up('sm')]: {
      width: '95%',
      alignSelf: 'center',
      marginBottom: '2%'
    }
  },

  buttonStyle: {
    flexGrow: 1,
    minWidth: '47%',
    borderRadius: '10px',
    alignContent: 'center',
  },

  darkButton: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.primary.main,
  },

  buttonLabel: {
    gap: '0.4rem',
    fontSize: '1rem',
    [theme.breakpoints.up('md')]: {
      fontSize: '1.7rem'
    },
  },

  whiteLabel: {
    color: theme.palette.common.white,
    fill: theme.palette.common.white,
  },

  iconSize: {
    width: '1.3rem',
    [theme.breakpoints.up('md')]: {
      width: '2rem'
    }
  },

  cardContainer: {
    padding: '0 0.25rem',
    alignItems: 'center',
    justifyContent: 'space-between'
  },

  infoContainer: {
    margin: '0.3rem',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  labelFont: {
    fontSize: '0.6rem',
    color: theme.palette.grey[400],
    marginBottom: '-0.25rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '0.75rem',
    }
  },

  contentFont: {
    fontSize: '0.75rem',
    color: theme.palette.common.black,
    [theme.breakpoints.up('sm')]: {
      fontSize: '0.8rem',
    }
  },

  removeButtonStyle: {
    height: 'fit-content',
    width: '4rem',
    borderRadius: '10px',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.error.main,
  },

  buttonIcon: {
    height: '3vh',
    width: '3vh',
    margin: '0.3vh 0'
  },

  cardLimit: {
    '& div.card': {
      width: 'fit-content'
    }
  },

  cardStyle: {
    padding: '0 0.25rem',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      width: '95vw',
    }
  },

  inputLote: {
    flexGrow: 1,
    maxWidth: '18%',
    [theme.breakpoints.down('sm')]: {
      maxWidth: "20%"
    }
  },

  inputDatasLote: {
    flexGrow: 1,
    maxWidth: '32%',
    [theme.breakpoints.down('sm')]: {
      maxWidth: "29%"
    }
  },

  inputQtdLote: {
    flexGrow: 1,
    maxWidth: '11%',
    [theme.breakpoints.down('sm')]: {
      maxWidth: "14%"
    }
  },

  inputMedStyle: {
    borderRadius: '10px',
    height: '3.5rem'
  },

  addButtonStyle: {
    borderRadius: '10px',
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center',
    width: '4rem',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginBottom: '0.3rem'
    }
  },
}));